// actionTypes.js
export const SET_CURRENT_PAGE_SOUSCRIPTION = 'SET_CURRENT_PAGE_SOUSCRIPTION';
export const SET_VALUE_SOUSCRIPTION = 'SET_VALUE_SOUSCRIPTION';
export const SET_SELECTED_OPTION_SOUSCRIPTION = 'SET_SELECTED_OPTION_SOUSCRIPTION';
export const SET_SORT_FIELD_SOUSCRIPTION = 'SET_SORT_FIELD_SOUSCRIPTION';
export const SET_ORDER_SOUSCRIPTION = 'SET_ORDER_SOUSCRIPTION';
export const SET_EN_COURS_SOUSCRIPTION = 'SET_EN_COURS_SOUSCRIPTION';
export const SET_VALIDEES_SOUSCRIPTION = 'SET_VALIDEES_SOUSCRIPTION';
export const SET_ANNULEES_SOUSCRIPTION = 'SET_ANNULEES_SOUSCRIPTION';
export const SET_STATUT_SOUSCRIPTION = 'SET_STATUT_SOUSCRIPTION';
export const SET_CATEGORIE_SOUSCRIPTION = 'SET_CATEGORIE_SOUSCRIPTION';
